const url = `${process.env.REACT_APP_CLIENT_ADMIN_ENTRYPOINT}/docs.json` || "http://api-admin/api/docs.json"
export const ENTRYPOINT = `${url}?v=${process.env.REACT_APP_RELEASE_VERSION}`

export const BASE_URL = process.env.REACT_APP_BASE_URL